export default {
  name: 'marking--turnoverType',
};